import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { ProcedureData } from "../models/procedure.model";

@Injectable({
  providedIn: "root",
})
export class ProceduresService {
  constructor(private http: HttpClientService) {}

  createProcedure(account_id: number, procedure_data: ProcedureData): Observable<any> {
    return this.http
      .post(`/api/accounts/${account_id}/procedures`, procedure_data)
      .pipe(tap((_) => console.log("ProceduresService.createProcedure: Ok")));
  }

  getProcedure(account_id: number, procedure_id: number): Observable<any> {
    return this.http
      .get(`/api/accounts/${account_id}/procedures/${procedure_id}`)
      .pipe(tap((_) => console.log("ProceduresService.getProcedure: Ok")));
  }

  updateProcedure(account_id: number, procedure_id: number, procedure_data: ProcedureData): Observable<any> {
    return this.http
      .put(`/api/accounts/${account_id}/procedures/${procedure_id}`, procedure_data)
      .pipe(tap((_) => console.log("ProceduresService.updateProcedure: Ok")));
  }

  deleteProcedure(account_id: number, procedure_id: number): Observable<any> {
    return this.http
      .delete(`/api/accounts/${account_id}/procedures/${procedure_id}`)
      .pipe(tap((_) => console.log("ProceduresService.deleteProcedure: Ok")));
  }
}
